export enum KhotcoinTransactionTypeEnum {
  TOP_UP = 'TOP_UP',
  BOT_FEE = 'BOT_FEE',
  INSURANCE = 'INSURANCE',
  TOP_UP_BY_ADMIN = 'TOP_UP_BY_ADMIN',
}
